import { render, staticRenderFns } from "./AttendanceSampleUpdate.vue?vue&type=template&id=bd987aea&scoped=true"
import script from "./AttendanceSampleUpdate.vue?vue&type=script&lang=js"
export * from "./AttendanceSampleUpdate.vue?vue&type=script&lang=js"
import style0 from "./AttendanceSampleUpdate.vue?vue&type=style&index=0&id=bd987aea&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd987aea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd987aea')) {
      api.createRecord('bd987aea', component.options)
    } else {
      api.reload('bd987aea', component.options)
    }
    module.hot.accept("./AttendanceSampleUpdate.vue?vue&type=template&id=bd987aea&scoped=true", function () {
      api.rerender('bd987aea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolconfig/AttendanceSampleUpdate.vue"
export default component.exports